module.exports = __webpack_public_path__ + "static/media/08.Shambhu Hegde Award.55ba7e9d.jpg";